import React from 'react'

export interface AdminActionBarProps {
    children: React.ReactNode
    className?: string
}

const AdminActionBar: React.FC<AdminActionBarProps> = ({ children, className = '' }) => {
    return (
        <div className={`px-6 py-3 bg-gray-50 border-b border-gray-200 ${className}`}>
            <div className="flex flex-col space-y-3">
                <div className="flex items-center gap-3">{children}</div>
            </div>
        </div>
    )
}

export default AdminActionBar
